(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('collection-infinite-scroll')) {
    class CollectionInfiniteScroll extends HTMLElement {
      constructor() {
        super();
        this.loading = false;
        this.observer = null;
        this.button = null;
        this.status = null;
        this.handleButtonClick = this.loadNext.bind(this);
      }

      connectedCallback() {
        this.button = this.querySelector('.collection-infinite-scroll__button');
        this.status = this.querySelector('.collection-infinite-scroll__status');

        if (!this.button || this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.button.addEventListener('click', this.handleButtonClick);

        if ('IntersectionObserver' in window && this.dataset.nextUrl) {
          this.observer = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) {
                this.loadNext();
              }
            },
            { rootMargin: '800px 0px' }
          );

          this.observer.observe(this);
        }
      }

      disconnectedCallback() {
        if (this.button) {
          this.button.removeEventListener('click', this.handleButtonClick);
        }

        if (this.observer) {
          this.observer.disconnect();
        }
      }

      async loadNext() {
        if (this.loading || !this.dataset.nextUrl) return;

        this.loading = true;
        this.setAttribute('aria-busy', 'true');

        if (this.button) {
          this.button.disabled = true;
        }

        if (this.status) {
          this.status.textContent = this.dataset.loadingLabel || '';
        }

        try {
          const response = await fetch(this.dataset.nextUrl, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });

          if (!response.ok) {
            throw new Error('Unable to load more products');
          }

          const html = await response.text();
          const nextDocument = new DOMParser().parseFromString(html, 'text/html');
          const incomingGrid = nextDocument.querySelector('#product-grid');
          const incomingLoader = nextDocument.querySelector('collection-infinite-scroll');
          const currentCollection = this.closest('.collection');
          const currentGrid = currentCollection ? currentCollection.querySelector('#product-grid') : null;

          if (!incomingGrid || !currentGrid) {
            throw new Error('Product grid not found');
          }

          Array.from(incomingGrid.children).forEach((item) => {
            item.classList.remove('scroll-trigger', 'animate--slide-in');
            item.removeAttribute('data-cascade');
            item.style.removeProperty('--animation-order');
            currentGrid.appendChild(item);
          });

          const nextUrl = incomingLoader ? incomingLoader.dataset.nextUrl : '';
          this.dataset.nextUrl = nextUrl || '';

          if (!this.dataset.nextUrl) {
            if (this.button) {
              this.button.hidden = true;
            }

            if (this.observer) {
              this.observer.disconnect();
            }
          }
        } catch (error) {
          if (this.button) {
            this.button.hidden = false;
          }
        } finally {
          this.loading = false;
          this.removeAttribute('aria-busy');

          if (this.button && this.dataset.nextUrl) {
            this.button.disabled = false;
          }

          if (this.status) {
            this.status.textContent = '';
          }
        }
      }
    }

    customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
  }

  } catch(e) { console.error(e); }
})();
})();
